var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeopleBadgeColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128.52 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient--people",
    x1: 3.58,
    y1: -754.93,
    x2: 28.24,
    y2: -779.58,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -751.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f75e5"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "people-badge-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.32,15.91c0,12.33-3.08,15.41-15.41,15.41S.5,28.24.5,15.91,3.59.5,15.91.5,31.32,3.58,31.32,15.91Z",
    fill: "url(#linear-gradient--people)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.07,9.31A3.13,3.13,0,1,1,10,12.44a3.12,3.12,0,0,1,3.12-3.13Zm4.74,13.2H8.31V19.66a2.86,2.86,0,0,1,2.85-2.85H15a2.86,2.86,0,0,1,2.85,2.85h0Zm2.44-11.33a2.34,2.34,0,1,1-2.34,2.34h0A2.34,2.34,0,0,1,20.25,11.18Zm3.26,9.43H18.76v-.95a3.57,3.57,0,0,0-.31-1.48,1.47,1.47,0,0,0-.1-.22l-.09-.17a2.07,2.07,0,0,0-.15-.25,1.76,1.76,0,0,1,1.41-.73H21.8a1.72,1.72,0,0,1,1.71,1.71Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.05,8.39a7.38,7.38,0,0,0-4.75,1.7L42,9.34a.81.81,0,0,0-.83-.62h-.83a.94.94,0,0,0-.91.91v21a.93.93,0,0,0,.91.91H42.2a.91.91,0,0,0,1-.81V23.87a8.55,8.55,0,0,0,3.74.93c4.24,0,7.56-3.61,7.56-8.22S51.22,8.39,47.05,8.39Zm3.75,8.19a4.48,4.48,0,0,1-4.23,4.71h-.08a6.32,6.32,0,0,1-3.38-1V13.92a4,4,0,0,1,3.51-2c2.42,0,4.18,2,4.18,4.67Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.58,8.39a7.83,7.83,0,0,0-7.83,7.84c0,.12,0,.24,0,.35a7.78,7.78,0,0,0,7.33,8.21l.53,0a8.84,8.84,0,0,0,5.8-1.94.78.78,0,0,0,.24-1.09,1.15,1.15,0,0,0-.14-.17l-.9-1.4a.72.72,0,0,0-.46-.34.92.92,0,0,0-.69.23,5.84,5.84,0,0,1-3.65,1.26,4.36,4.36,0,0,1-4.41-3.83H69.83a.91.91,0,0,0,.88-.82c0-.28.07-.82.07-1.09a7.06,7.06,0,0,0-6.87-7.23Zm-.06,3.18a3.46,3.46,0,0,1,3.6,3.14H59.6A3.73,3.73,0,0,1,63.52,11.57Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.87,8.39a8.21,8.21,0,1,0,8,8.42v-.26A8.2,8.2,0,0,0,79.87,8.39Zm4.38,8.16a4.41,4.41,0,0,1-8.79.68,3.86,3.86,0,0,1,0-.68,4.4,4.4,0,1,1,8.79-.5A4.17,4.17,0,0,1,84.25,16.55Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.59,8.39a7.36,7.36,0,0,0-4.75,1.7l-.3-.75a.81.81,0,0,0-.83-.62h-.83a.94.94,0,0,0-.91.91v21a.91.91,0,0,0,.91.91h1.86a.9.9,0,0,0,1-.81s0-.07,0-.1V23.86a8.39,8.39,0,0,0,3.74.94c4.24,0,7.56-3.61,7.56-8.22S101.75,8.39,97.59,8.39Zm-3.94,5.53a4,4,0,0,1,3.51-2c2.42,0,4.18,2,4.18,4.67a4.48,4.48,0,0,1-4.23,4.71H97a6.34,6.34,0,0,1-3.38-1Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.09,1.67H110a.91.91,0,0,1,.91.91v21a.91.91,0,0,1-.91.91h-1.87a.9.9,0,0,1-.9-.91v-21A.9.9,0,0,1,108.09,1.67Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.83,8.39A7.82,7.82,0,0,0,113,16.23v.35a7.78,7.78,0,0,0,7.33,8.21l.53,0a8.84,8.84,0,0,0,5.8-1.94.78.78,0,0,0,.1-1.26l-.9-1.4a.7.7,0,0,0-.45-.34,1,1,0,0,0-.7.23,5.8,5.8,0,0,1-3.65,1.26,4.35,4.35,0,0,1-4.4-3.83h10.42a.89.89,0,0,0,.87-.82,10.13,10.13,0,0,0,.07-1.09,7.06,7.06,0,0,0-6.87-7.23Zm-.07,3.18a3.45,3.45,0,0,1,3.6,3.14h-7.52A3.73,3.73,0,0,1,120.76,11.57Z",
    fill: "#444"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleBadgeColor);
export default __webpack_public_path__ + "static/media/people-badge-color.9378d89572809101b870210ae09873f7.svg";
export { ForwardRef as ReactComponent };